import { Component, OnDestroy, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import {  AutomatedTestArea } from '../models/ast-element.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { MenuItem } from '../../../shared-components/controls/menus/menu-item.model';
import { AreaAddEditModalComponent } from './area-add-edit-modal.component';

@AutoUnsubscribe()
@Component({
    selector: 'AreaListModal',
    templateUrl: './area-list.component.html',
    styleUrls: ['./area-list.component.css']
})

export class AreaListModalComponent implements OnDestroy, OnInit {

    PageTitle: string;
    Message: string;

    areaAddEditDialogRef: MatDialogRef<AreaAddEditModalComponent>;

    dataSource: TylerMatTableDataSource;

     @ViewChild(MatPaginator) paginator: MatPaginator;

    topActionMenuItems: string[] = ['Update'];

    areaToggle = 1;

    allAreas: AutomatedTestArea[] = [];
    distinctTestAreas: AutomatedTestArea[] = [];
    selectedArea: AutomatedTestArea[] = []; // This is used to set the Area ID

    elemAreas: string[] = [];
    elemSubAreas: string[] = [];
    allControlNames: string[] = [];

    elementArea: string;
    elementSubArea: string;
    elementControlName: string;
    newModuleName: string;
    newPortalName: string;
    areaId: number;
    areaName: string;
    subAreaName: string;


    @ViewChild('NewAreaName') module: ElementRef;

    @ViewChild('NewPortalName') portal: ElementRef;

    newArea: AutomatedTestArea = {
        Area_ID: 0,
        AreaName: '',
        SubAreaName: ''
    };

     // ----------Angular Material------------------------------------
     angularMatData = new TylerMatTableDataSource();
     @ViewChild(MatSort, { static: true }) sort: MatSort;
     columnsToDisplay: string[] = []
     subscriptions: Subscription[] = [];

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<AreaListModalComponent>,
        _areaAddEditDialogRef: MatDialogRef<AreaAddEditModalComponent>,
        private _areaAddEditDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.PageTitle = data.PageTitle;
        this.Message = data.Message;
    }

    ngOnInit() {
        this. columnsToDisplay = ['AreaName', 'SubAreaName', 'Action'];
        switch(this.PageTitle) {

            case 'Module / Portal List': {
                this.getAllModulesAndPortals();
                break;
            }

            case 'Page & Tab / View List': {
                this.getAllPagesAndTabs();
                break;
            }

            default:{
                alert("Mistakes have been made.");
                break;
            }
        }
    }

    ngOnDestroy() { }

    cancelClick() {
        this.dialogRef.close(false);
    }

    setModuleName() {
        this.newModuleName = this.module.nativeElement.value;
    }

    setPortalName() {
        this.newPortalName = this.portal.nativeElement.value;
    }

    setAreaId(id: number) {
        this.areaId = id;
    }

    setAreaName(areaName: string){
        this.areaName = areaName;
    }

    setSubAreaName(subAreaName: string){
        this.subAreaName = subAreaName;
    }

    getAllPagesAndTabs() {
        this.reportService.getAutomatedTestAreas(0).subscribe(myAreas => {
            this.allAreas = myAreas;

            this.allAreas = this.allAreas.filter(a => a.AreaName !== "Classroom360"
                                                    && a.AreaName !== "Student360"
                                                    && a.AreaName !== "General"
                                                    && a.AreaName !== "AcademicHistory"
                                                    && a.AreaName !== "Practice360"
                                                    && a.AreaName !== "Behavior");

            // this.allAreas.sort((a, b) => a.SubAreaName > b.SubAreaName ? 1 : -1);
            this.allAreas.sort((a, b) => a.AreaName > b.AreaName ? 1 : -1);

            this.dataSource = new TylerMatTableDataSource(this.allAreas);
            this.dataSource.paginator = this.paginator;
        });
    }

    getAllModulesAndPortals() {
        this.reportService.getAutomatedTestAreas(0).subscribe(myAreas => {
            this.allAreas = myAreas;

            this.allAreas = this.allAreas.filter(a => a.AreaName === "Classroom360"
                                                    || a.AreaName === "Student360"
                                                    || a.AreaName === "General"
                                                    || a.AreaName === "AcademicHistory"
                                                    || a.AreaName === "Practice360"
                                                    || a.AreaName === "Behavior");

            // this.allAreas.sort((a, b) => a.SubAreaName > b.SubAreaName ? 1 : -1);
            this.allAreas.sort((a, b) => a.AreaName > b.AreaName ? 1 : -1);

            this.dataSource = new TylerMatTableDataSource(this.allAreas);
            this.dataSource.paginator = this.paginator;
        });
    }

    getSubAreas(areaName: string) {
        const filteredAreas = this.allAreas.filter(a => a.AreaName === areaName).sort((a, b) => a.SubAreaName > b.SubAreaName ? 1 : -1);

        for (const item of filteredAreas) {
            this.elemSubAreas.push(item.SubAreaName);
        }
    }

    createNewArea() {
        // Assemble the new area from the information that has been input by the user
        this.setModuleName();
        this.setPortalName();

        this.newArea.AreaName = this.newModuleName;
        this.newArea.SubAreaName = this.newPortalName;

        if (this.newModuleName === '' || this.newModuleName === undefined) {
                alert('Please make sure that there is a Module name.');
        } else {
            // Save the new area to the AST_Areas table
            this.reportService.saveAutomatedTestArea(this.newArea).subscribe(results => { });

            alert(`New module / portal ${ this.newModuleName } / ${ this.newPortalName } successfully created.`);

            this.dialogRef.close(true);
        }
    }


    // This method is executed when clicking the 'Add Portal' button on the Module / Portal List page.
    showPortalAddWindow() {

        this.distinctTestAreas = this.allAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
          );

        this.areaAddEditDialogRef = this._areaAddEditDialog.open(AreaAddEditModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Add Portal',
              Message: 'Create a new portal.',
              distinctTestAreas: this.distinctTestAreas,
            }
          });

          this.areaAddEditDialogRef.afterClosed().subscribe( res => {
            this.ngOnInit();
       })
    }

    // This method is executed when clicking the 'Add Portal' button on the Module / Portal List page.
    showPageTabAddWindow() {

        this.distinctTestAreas = this.allAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
          );

        this.areaAddEditDialogRef = this._areaAddEditDialog.open(AreaAddEditModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Add Page and/or Tab / View',
              Message: 'Create a new page and/or tab / view.',
              distinctTestAreas: this.distinctTestAreas,
            }
          });

          this.areaAddEditDialogRef.afterClosed().subscribe( res => {
            this.ngOnInit();
       })
    }

    // This method is executed upon clicking 'Update' in the Action menu; it will display the Module /Portal Update Tool if an area has been selected.
    showUpdatePortalWindow() {
        this.distinctTestAreas = this.allAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
          );

        if (this.areaId === undefined) {
                alert('Please make sure that all of the fields are populated.');
        } else {
            this.areaAddEditDialogRef = this._areaAddEditDialog.open(AreaAddEditModalComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: {
                  PageTitle: 'Update Portal',
                  Message: 'Update an existing portal.',
                  distinctTestAreas: this.distinctTestAreas,
                  areaId: this.areaId,
                  areaName: this.areaName,
                  subAreaName: this.subAreaName,
                }
              });


            this.areaAddEditDialogRef.afterClosed().subscribe( res => {
                this.ngOnInit();
           })
        }
    }


    // This method is executed upon clicking 'Update' in the Action menu; it will display the Module /Portal Update Tool if an area has been selected.
    showUpdatePageTabViewWindow() {
        this.distinctTestAreas = this.allAreas.filter(
            (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
          );

        if (this.areaId === undefined) {
                alert('Please make sure that all of the fields are populated.');
        } else {
            this.areaAddEditDialogRef = this._areaAddEditDialog.open(AreaAddEditModalComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: {
                  PageTitle: 'Update Page and / or Tab / View',
                  Message: 'Update an existing page, tab, or view.',
                  distinctTestAreas: this.distinctTestAreas,
                  areaId: this.areaId,
                  areaName: this.areaName,
                  subAreaName: this.subAreaName,
                }
              });


            this.areaAddEditDialogRef.afterClosed().subscribe( res => {
                this.ngOnInit();
           })
        }
    }

    updateArea() {
        // Assemble the new area from the information that has been input by the user
        this.setModuleName();
        this.setPortalName();
        this.newArea.AreaName = this.newModuleName;
        this.newArea.SubAreaName = this.newPortalName;

        if (this.newModuleName === '' || this.newModuleName === undefined) {
                alert('Please make sure that there is a Module or Page name.');
        } else {
            // Save the new area to the AST_Areas table
            this.reportService.updateAutomatedTestArea(this.areaId, this.newArea).subscribe(results => { });

            alert(`${ this.newModuleName} / ${ this.newPortalName } successfully updated.`);

            this.dialogRef.close(true);

        }



    }

    // Table-related methods --------------------------------

    getAriaRow(row: any): string {
        return '';
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    actionMenuClick(menuItem: MenuItem) {
        // const data: ElementsAndAreasModalComponent = menuItem.data;
        switch (menuItem.itemName) {
            case 'Update':
            if(this.PageTitle === 'Module / Portal List') {
                this.showUpdatePortalWindow();
            }  else {
                this.showUpdatePageTabViewWindow();
            }
                break;
        }
    }


}
